export function formatChartCategory(value: string): string {
  const monthOnly = /^\d{4}-\d{2}$/.test(value);
  if (!monthOnly && !/^\d{4}-\d{2}-\d{2}(?:T|$)/.test(value)) return value.replace(/_/g, ' ');
  const normalized = monthOnly ? `${value}-01T00:00:00Z`
    : /T/.test(value) && !/(?:Z|[+-]\d{2}:?\d{2})$/.test(value) ? `${value}Z` : value;
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    ...(date.getUTCDate() === 1 ? { year: 'numeric' as const } : { day: 'numeric' as const }),
    timeZone: 'UTC',
  }).format(date);
}

export const isMonthCategory = (value: string): boolean => /^\d{4}-\d{2}(?:$|-01(?:T|$))/.test(value);

export function formatChartAxisValue(value: number, unit: string, maximum: number): string {
  if (unit === 'currency' && maximum >= 1_000_000)
    return `${new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value / 1_000_000)}M`;
  if (unit === 'percent') return `${new Intl.NumberFormat('en-US', { maximumFractionDigits: 1 }).format(value * 100)}%`;
  return new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(value);
}
